import React from 'react'
import classnames from 'classnames/bind'
// @ts-ignore no types for scss
import styles from './cellStyles.scss'

const cx = classnames.bind(styles)

interface RadioCellProps {
  rowIndex: number
  value: { id: string }
  selectedMemberId: string | null
  onSelectMember: (memberId: string) => void
  width?: number
  height?: number
}

const RadioCell: React.FC<RadioCellProps> = ({
  value,
  rowIndex,
  selectedMemberId,
  onSelectMember,
}) => {
  const isSelected = value?.id === selectedMemberId

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    if (value?.id) {
      onSelectMember(value.id)
    }
  }

  return (
    <div className={cx('radio-cell')}>
      <input
        type='radio'
        name='member_select'
        checked={isSelected}
        onClick={handleClick}
        onChange={() => {}} // controlled component - toggle handled by onClick
        data-elm-id={`select_member_${rowIndex}`}
      />
    </div>
  )
}

export default RadioCell
